import { Component } from '@angular/core';
import { StorageService } from '@shared/services/storage.service';
import { Event, NavigationEnd, Router } from '@angular/router';
import { LanguageService } from '@shared/services/language.service';
import { GoogleLoginOneClickService } from './shared/services/auth/google-login-one-click.service';
import { logMcdEnvironmentDiagnostics } from '@shared/mcd-diagnostics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    public googleLoginService: GoogleLoginOneClickService,
    public storage: StorageService,
    public router: Router,
    public languageService: LanguageService
  ) {
    logMcdEnvironmentDiagnostics();
    this.languageService.init();
    this.scrollToTopAfterChangePage();
    this.disableDragAndDrop();
    this.clearUkraineCookieIfBlackHole();
    this.clearWcdCookieIfBlackHole();
    this.googleLoginService.init();
  }

  clearUkraineCookieIfBlackHole() {
    if (
      this.storage.isAuthFromUkraine &&
      this.router.url.search('helpukraine') == -1 &&
      this.router.url.search('articles/how-to-help-ukraine') == -1 &&
      this.router.url.search('help-ukraine-request/create') == -1
    ) {
      this.storage.setAuthFromUkraine(false);
    }
  }

  clearWcdCookieIfBlackHole() {
    if (this.storage.isAuthFromWCD && this.router.url.search('worldcleanupday') == -1) {
      this.storage.setAuthFromWcd(false);
    }
  }

  scrollToTopAfterChangePage() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (
          !(event.url.split('?').length > 1) &&
          event.url.indexOf('#') == -1 &&
          !this.storage.noScrollAfterChangeRoute
        ) {
          setTimeout(() => {
            window.scrollTo(0, 0);
          });
        } else {
          this.storage.noScrollAfterChangeRoute = false;
        }
      }
    });
  }

  disableDragAndDrop() {
    window.addEventListener(
      'dragover',
      (e) => {
        e.preventDefault();
      },
      false
    );
    window.addEventListener(
      'drop',
      (e) => {
        e.preventDefault();
      },
      false
    );
  }
}
